import { render, staticRenderFns } from "./CreateAutomaticLabelsModal.vue?vue&type=template&id=c273f2ac&scoped=true"
import script from "./CreateAutomaticLabelsModal.vue?vue&type=script&lang=ts"
export * from "./CreateAutomaticLabelsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c273f2ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c273f2ac')) {
      api.createRecord('c273f2ac', component.options)
    } else {
      api.reload('c273f2ac', component.options)
    }
    module.hot.accept("./CreateAutomaticLabelsModal.vue?vue&type=template&id=c273f2ac&scoped=true", function () {
      api.rerender('c273f2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/CreateAutomaticLabelsModal.vue"
export default component.exports